var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    fill: "white",
    stroke: "#D2D2D2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_660)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_606_660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3161 17.0977C22.1785 16.7076 21.9232 16.3698 21.5854 16.1309C21.2477 15.892 20.8441 15.7638 20.4304 15.764H18.8824C18.4408 15.7617 18.014 15.9232 17.6846 16.2173C17.3551 16.5115 17.1464 16.9173 17.0989 17.3564C17.0513 17.7955 17.1683 18.2366 17.4271 18.5944C17.6859 18.9523 18.0683 19.2014 18.5001 19.2937L20.8573 19.808C21.3393 19.9135 21.7653 20.1934 22.0534 20.5939C22.3415 20.9944 22.4715 21.4873 22.4184 21.9778C22.3652 22.4683 22.1327 22.9219 21.7654 23.2514C21.3982 23.5809 20.9221 23.763 20.4287 23.7629H19.0967C18.2259 23.7629 17.4853 23.2074 17.211 22.4309M19.7636 15.764V13.7634M19.7636 25.7634V23.7646M11.4253 31.1394V26.8537H15.711",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9509 17.9497C31.406 20.3758 31.0427 22.8843 29.9179 25.0816C28.7931 27.2788 26.9706 29.0404 24.7364 30.0898C22.5022 31.1393 19.9828 31.4171 17.5736 30.8798C15.1644 30.3425 13.0018 29.0205 11.4252 27.1212M9.04919 22.0503C8.59409 19.6242 8.95744 17.1157 10.0822 14.9185C11.207 12.7212 13.0295 10.9596 15.2637 9.91022C17.4979 8.86079 20.0173 8.58292 22.4265 9.12022C24.8357 9.65752 26.9983 10.9796 28.5749 12.8789",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.575 8.8606V13.1463H24.2893",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_606_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscription_icon.6fc908d25529831857bc4742c0d51100.svg";
export { ForwardRef as ReactComponent };